export default "__VITE_ASSET__DE$kUEcP__"